import { NavLink, Outlet } from "react-router-dom";
import { ContentJson } from "../../model/ContentJson";

export const Layout: React.FC<{ contentJson: ContentJson }> = ({ contentJson }) => {

    function activeLink(isActive: boolean): React.CSSProperties | undefined {
        let res: React.CSSProperties = {};
        if (isActive) {
            res = { backgroundColor: "yellow", color: "blue" }
        }
        return res;
    }

    function getUlNavLinks() {
        return (
            <ul className="navigator-list">
                {Object.entries(contentJson).map(([key, value]) => (
                    <li key={key} className="navigator-item">
                        <NavLink style={({ isActive }: { isActive: boolean }) => activeLink(isActive)} to={`/${key}`}>{value}</NavLink></li>
                ))
                }
            </ul>
        )
    }

    return <div className="layout-main">
        <nav className="layout-menu">
            {getUlNavLinks()}
        </nav>
        <nav className="layout-content">
            <Outlet></Outlet>
        </nav>
    </div>
}